/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LocationMarker/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function LocationMarker({
  children,
  viewPath = "/DesignSystem/Svgs/LocationMarker",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 32,
  height = 32
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="LocationMarker.Svg"
  data-view-path={viewPath}
 viewBox="0 0 32 32"
 style={{'--as-1-Z1DJ8R3': alignSelf,'--mt-2-Z1DJ8R3': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z1DJ8R3': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z1DJ8R3': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z1DJ8R3': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z1DJ8R3': opacity,'--w-7-Z1DJ8R3': typeof width === 'number' ? `${width}px` : width,'--h-8-Z1DJ8R3': typeof height === 'number' ? `${height}px` : height}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="LocationMarker.SvgPath"
  data-view-path={viewPath}
 d="M25.1 12.28c0 7.01-9.1 16.54-9.1 16.54s-9.1-9.53-9.1-16.54c0-5.03 4.07-9.1 9.1-9.1s9.1 4.07 9.1 9.1z"
 className="views-block"
/>
</svg>
{children}
</React.Fragment>)
}